import { render, staticRenderFns } from "./MailMessageIcon.vue?vue&type=template&id=7a24beb0&"
import script from "./MailMessageIcon.vue?vue&type=script&lang=js&"
export * from "./MailMessageIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports